import AppDrawer from "components/Drawers/AppDrawer";
import AppColorPicker from "elements/AppColorPicker";
import { Fragment, useEffect, useMemo, useState } from "react";
import { Button, FormGroup, Input } from "reactstrap";
import { sanitizeWidget } from "utils/DashboardUtils";
import AppSpinner from "../../../elements/AppSpinner";
import LockHeightSetting from "./LockHeightSetting";
import LockWidthSetting from "./LockWidthSetting";
import Constants from "../../../utils/Constants";
import AppMentionsInput from "../../Inputs/AppMentionsInput";
import useModule from "../../../hooks/useModule";

const sizeData = [
  { icon: "size-s", val: "h3" },
  { icon: "size-m", val: "h2" },
  { icon: "size-l", val: "h1" },
];
const alignData = [
  { icon: "format-align-left", val: "start" },
  { icon: "format-align-center", val: "center" },
  { icon: "format-align-right", val: "end" },
];

const HeaderWidgetSettings = ({
  open,
  onClose,
  setSettings,
  section,
  updateWidget,
  isUpdating,
  theme,
  record,
}) => {
  const [widget, setWidget] = useState(null);
  const { module } = useModule(record?._ModuleAPIName);

  const options = useMemo(() => {
    if (!module?.Fields?.length) return [];

    return module?.Fields?.map((f) => ({ id: f?.APIName, display: f?.Name }));
  }, [module?.Fields]);

  const handleSave = () => {
    if (JSON.stringify(widget) === JSON.stringify(section)) {
      return onClose();
    }

    sanitizeWidget(widget);

    updateWidget(widget, onClose);
  };

  const updateLocalWidget = (key, val) => {
    setWidget((prev) => ({ ...prev, [key]: val }));
  };

  const handleTitleInputChange = (e, newValue, newPlainTextValue, mentions) => {
    setWidget((prev) => ({
      ...prev,
      titleMentions: mentions,
      Name: newValue,
    }));
  };

  const handleDescriptionInputChange = (
    e,
    newValue,
    newPlainTextValue,
    mentions
  ) => {
    setWidget((prev) => ({
      ...prev,
      descriptionMentions: mentions,
      Description: newValue,
    }));
  };

  useEffect(() => {
    setWidget(JSON.parse(JSON.stringify(section)));
  }, [section]);

  return (
    <AppDrawer
      open={open}
      onClose={onClose}
      headerTitle="Header Settings"
      headerOptions={
        <Button
          color="primary"
          size="sm"
          onClick={handleSave}
          disabled={!widget?.Name || isUpdating}
        >
          {isUpdating ? <AppSpinner size="sm" color="white" /> : "Save"}
        </Button>
      }
      bodyCSS="pt-3"
      body={
        <>
          <FormGroup>
            <h5>Title</h5>
            <AppMentionsInput
              value={widget?.Name ?? ""}
              handleInputChange={handleTitleInputChange}
              options={options}
              placeholder="Header Title"
            />
          </FormGroup>
          <FormGroup>
            <h5>Description</h5>
            <AppMentionsInput
              value={widget?.Description ?? ""}
              handleInputChange={handleDescriptionInputChange}
              options={options}
              placeholder="Header Description"
            />
          </FormGroup>
          <FormGroup>
            <AppColorPicker
              title="Background Color"
              value={widget?.Color}
              onChange={(newColor) => updateLocalWidget("Color", newColor)}
              theme={Constants.DASHBOARD_COLOR_THEMES?.[theme]}
              onClear={() => updateLocalWidget("Color", undefined)}
            />
          </FormGroup>
          <hr className="mt-0 mb-3" />
          <FormGroup>
            <h5>Size</h5>
            {sizeData.map((size) => (
              <Fragment key={size.icon}>
                <Button
                  className="btn-icon-only border"
                  size="sm"
                  outline={widget?.Size !== size.val}
                  color="secondary"
                  onClick={() => updateLocalWidget("Size", size.val)}
                >
                  <i className={`mdi mdi-${size.icon}`}></i>
                </Button>
              </Fragment>
            ))}
          </FormGroup>
          <FormGroup>
            <h5>Alignment</h5>
            {alignData.map((size) => (
              <Fragment key={size.icon}>
                <Button
                  className="btn-icon-only border"
                  size="sm"
                  outline={widget?.Alignment !== size.val}
                  color="secondary"
                  onClick={() => updateLocalWidget("Alignment", size.val)}
                >
                  <i className={`mdi mdi-${size.icon}`}></i>
                </Button>
              </Fragment>
            ))}
          </FormGroup>
          <hr className="mt-0 mb-3" />
          {/* Disabled for now */}
          {/* <LockWidthSetting
            section={widget}
            updateSection={updateLocalWidget}
          />
          <LockHeightSetting
            section={widget}
            updateSection={updateLocalWidget}
          /> */}
        </>
      }
    />
  );
};

export default HeaderWidgetSettings;
